import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hook/use-http";
import ChartLoader from "../ChartLoader";
import NoData from "../NoData";
import { Chart } from 'react-google-charts';
import BucketsTableBMSMin from "../BucketsTableBMSMin";
import BucketsTableBMSMax from "../BucketsTableBMSMax";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

let res_result
let Maxchartdata
let bartype

export default function BMS_fleet({ apiend, gloablfilter, type, chartBMSDropdown }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();


  let modal_title = "";

  const appyData = (data) => {
    res_result = data;
    

    let responce = {
      "<2.6": 0,
      "2.7": 0,
      "2.8": 0,
      "2.9": 0,
      "3": 0,
      "3.1": 0,
      "3.2": 0,
      "3.3": 0,
      "3.4": 0,
      "3.5": 0,
      "3.6": 0,
      "3.7": 0,
      "3.8": 0,
      "3.9": 0,
      "4": 0,
      ">=4": 0,
    };

    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;

      temp_result.map(d => {
        let value = d[chartBMSDropdown].value;
        value = d[chartBMSDropdown].value.toFixed(3);

        if (value >= 0 && value < 2.6) {
          responce["<2.6"] = responce["<2.6"] + 1;
        } else if (value >= 2.6 && value < 2.7) {
          responce["2.7"] = responce["2.7"] + 1;
        } else if (value >= 2.7 && value < 2.8) {
          responce["2.8"] = responce["2.8"] + 1;
        } else if (value >= 2.8 && value < 2.9) {
          responce["2.9"] = responce["2.9"] + 1;
        } else if (value >= 2.9 && value < 3) {
          responce["3"] = responce["3"] + 1;
        } else if (value >= 3 && value < 3.1) {
          responce["3.1"] = responce["3.1"] + 1;
        } else if (value >= 3.1 && value < 3.2) {
          responce["3.2"] = responce["3.2"] + 1;
        } else if (value >= 3.2 && value < 3.3) {
          responce["3.3"] = responce["3.3"] + 1;
        } else if (value >= 3.3 && value < 3.4) {
          responce["3.4"] = responce["3.4"] + 1;
        } else if (value >= 3.4 && value < 3.5) {
          responce["3.5"] = responce["3.5"] + 1;
        } else if (value >= 3.5 && value < 3.6) {
          responce["3.6"] = responce["3.6"] + 1;
        } else if (value >= 3.6 && value < 3.7) {
          responce["3.7"] = responce["3.7"] + 1;
        } else if (value >= 3.7 && value < 3.8) {
          responce["3.8"] = responce["3.8"] + 1;
        } else if (value >= 3.8 && value < 3.9) {
          responce["3.9"] = responce["3.9"] + 1;
        } else if (value >= 3.9 && value < 4) {
          responce["4"] = responce["4"] + 1;
        } else if (value >= 4) {
          responce[">=4"] = responce[">=4"] + 1;
        }
      })

      let res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);

      loop_keys = ["<2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5", "3.6", "3.7", "3.8", "3.9", "4", ">=4"]
      loop_keys.map(x => {
        if(type === 'Slow'){
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${"#348393"}}`]);
        }else{
          res_result_final.push([x, responce[x], `{stroke-width: 1;stroke-color: black;color:${"#F39C48"}}`]);
        }
    })
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }


    let colorMin, colorMax
    if (type === "Slow") {
      colorMax = "#348393"
      colorMin = "#89CCD8"
    } else {
      colorMin = "#FFD1A4"
      colorMax = "#F39C48"
    }
    const labels = ["<2.6", "2.7", "2.8", "2.9", "3", "3.1", "3.2", "3.3", "3.4", "3.5", "3.6", "3.7", "3.8", "3.9", "4", ">=4"];
    Maxchartdata = {
      labels,
      datasets: [
        {
          label: chartBMSDropdown,
          data: responce,
          backgroundColor: colorMax,
          borderColor: 'black',
          borderWidth: 1
        }
      ]
    };
  }
  let hAxis = {};

  modal_title = "BMS cell voltage - " + type + " chrg";
  hAxis = {
    gridlines: {
      color: 'transparent'
    },
    title: 'Range (Km)',
    minValue: 0,
    format: 'short',
    direction: 1,
    slantedText: true,
    slantedTextAngle: 90
  };
  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,

    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          // text: 'BMS cell voltage (V)'
          text: chartBMSDropdown
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
          align: 'start'
        }
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Vehicle Count'
        }
      },
    },

    plugins: {
      legend: {
        // position: "bottom"
        position: false
      },
    }
  };

  const options = {
    borderColor: "black", // Border color for the bars
      borderWidth: 2, 
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: chartBMSDropdown,
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },

    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" }
    , legend: "none",
  };


  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage_api/" + apiend, body: { filterdata: gloablfilter, type: type } }, appyData)
  }, [gloablfilter, type, chartBMSDropdown])

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> :
                <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
              )}
            </div>
          </div>
        </div>
      </div>
      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <WaterMark />
      {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> :
        <Chart chartType="ColumnChart" options={options} data={chartdata} width="100%" height="230px" chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;
  
                const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                if (count !== 0) {
                  let filtered_temp = [];
                  filtered_temp = apiresponce.filter(x => {
                    if (x[chartBMSDropdown].value< barvalue && x[chartBMSDropdown].value>= barvalue - 0.1) {
                      return x;
                    } else if (x[chartBMSDropdown].value> 4 && x[chartBMSDropdown].value<= 4 && barvalue === "4") {
                      return x
                    } else if (x[chartBMSDropdown].value< 2.6 && barvalue === "<2.6") {
                      return x
                    }
                  })
  
                  function compareObjects(object1, object2, key) {
                    const obj1 = object1[chartBMSDropdown].value
                    const obj2 = object2[chartBMSDropdown].value
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }
  
                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'value')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$("#exampleModal__" + apiend).modal('show');
                }
              }
            }
          }
          ]}/>
      )}

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{modal_title}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">Vin Number</th>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  {(bartype === 1) ? <BucketsTableBMSMax data={filteredData} /> : <BucketsTableBMSMin data={filteredData} />
                  }
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
